import { render, staticRenderFns } from "./textCell.vue?vue&type=template&id=8c994dba&scoped=true"
import script from "./textCell.vue?vue&type=script&lang=js"
export * from "./textCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c994dba",
  null
  
)

export default component.exports